import script from "./CMPGraficaBarras.vue?vue&type=script&setup=true&lang=js"
export * from "./CMPGraficaBarras.vue?vue&type=script&setup=true&lang=js"

import "./CMPGraficaBarras.vue?vue&type=style&index=0&id=00163404&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00163404"]])

export default __exports__